// src/firebase/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import config from "./config";

const app = initializeApp(config);
const auth = getAuth(app);
const db = getFirestore(app);
// const functions = getFunctions(app);
const functions = getFunctions(app, "asia-northeast2");

export { app, auth, db, functions };
